import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const carouselOnPLPNthCategorySelector = createSelector(testTargetOffersSelector, offers => offers.carouselOnPLPNthCategory || Empty.Object);

export { carouselOnPLPNthCategorySelector };
